// extracted by mini-css-extract-plugin
export default {"Logo_isLink":"q8u19"};